
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import { useToast } from "@/hooks/use-toast";

const Profile = () => {
  const navigate = useNavigate();
  const { user, loading } = useAuth();
  const { toast } = useToast();
  const [isNavigating, setIsNavigating] = useState(false);

  useEffect(() => {
    // If auth is still loading, wait
    if (loading) return;
    
    // Mark that navigation is in progress
    setIsNavigating(true);
    
    if (user) {
      console.log("Profile.tsx - User:", user);
      console.log("Profile.tsx - Profile type:", user.profileType);
      
      // Special case for marcofilipi94@gmail.com - always redirect to mentor profile
      if (user.email === "marcofilipi94@gmail.com") {
        navigate("/mentor-profile", { replace: true });
        return;
      }
      
      // Redirect based on profile type
      if (user.profileType === "mentor") {
        navigate("/mentor-profile", { replace: true });
      } else if (user.profileType === "mentee") {
        navigate("/mentee-profile", { replace: true });
      } else if (user.profileType === "both") {
        // For users with both types, default to mentor profile
        navigate("/mentor-profile", { replace: true });
      } else if (user.isAdmin) {
        // For admin users viewing profile, default to mentor profile
        navigate("/mentor-profile", { replace: true });
      } else {
        // If profile type is not set, default to mentee
        toast({
          title: "Profile Type Not Set",
          description: "Redirecting to mentee profile by default.",
          variant: "default",
        });
        navigate("/mentee-profile", { replace: true });
      }
    } else {
      // If no user data, redirect to login
      navigate("/login", { replace: true });
    }
  }, [navigate, user, loading, toast]);

  // This component will not render anything as it immediately redirects
  return null;
};

export default Profile;
